import React, { useEffect, useState } from "react";
import { Accordion, AccordionTab } from "primereact/accordion";


const Regua2024 = (props) => {

    const [atributos,setAtributos] = useState(props.atributos);
    const [atributosArray,setAtributosArray] = useState();
    const modeloRegua = [
        {percentual:'0,00% - 40,00%', cor:'div-red',legenda:'Altamente Deficiente',percentualPrevisto:'40'},
        {percentual:'40,01% - 60,00%', cor:'div-orange',legenda:'Deficiente',percentualPrevisto:'60'},
        {percentual:'60,01% - 80,00%', cor:'div-yellow',legenda:'Regular',percentualPrevisto:'80'},
        {percentual:'80,01% - 90,00%', cor:'div-green',legenda:'Bom',percentualPrevisto:'90'},
        {percentual:'90,01% - 110,00%', cor:'div-blue',legenda:'Ótimo',percentualPrevisto:'110'},
        {percentual:'110,01% - 120,00%', cor:'div-green',legenda:'Bom',percentualPrevisto:'120'},
        {percentual:'120,01% - 140,01%', cor:'div-yellow',legenda:'Regular',percentualPrevisto:'140'},
        {percentual:'140,01% - 160,00%', cor:'div-orange',legenda:'Deficiente',percentualPrevisto:'160'},
        {percentual:'160,01% +', cor:'div-red',legenda:'Altamente Deficiente',percentualPrevisto:'160+'}
    ]

    function handleArrow(array){
        let arrayCopy = array;
        arrayCopy.map((obj) => {
            if (obj.porcentagemPrevisto >= 0 && obj.porcentagemPrevisto <= 40) {
                obj.percentualPrevisto = '40';
            } else if (obj.porcentagemPrevisto > 40 && obj.porcentagemPrevisto <= 60) {
                obj.percentualPrevisto = '60';
            } else if (obj.porcentagemPrevisto > 60 && obj.porcentagemPrevisto <= 80) {
                obj.percentualPrevisto = '80';
            } else if (obj.porcentagemPrevisto > 80 && obj.porcentagemPrevisto <= 90) {
                obj.percentualPrevisto = '90';
            } else if (obj.porcentagemPrevisto > 90 && obj.porcentagemPrevisto <= 110) {
                obj.percentualPrevisto = '110';
            } else if (obj.porcentagemPrevisto > 110 && obj.porcentagemPrevisto <= 120) {
                obj.percentualPrevisto = '120';
            } else if (obj.porcentagemPrevisto > 120 && obj.porcentagemPrevisto <= 140) {
                obj.percentualPrevisto = '140';
            } else if (obj.porcentagemPrevisto > 140 && obj.porcentagemPrevisto <= 160) {
                obj.percentualPrevisto = '160';
            } else if (obj.porcentagemPrevisto > 160) {
                obj.percentualPrevisto = '160+';
            }
        })
        setAtributosArray(arrayCopy);
    };

    useEffect(() => {
        handleArrow(atributos);
    },[atributos])

    useEffect(() => {
        setAtributos(props.atributos);
    },[props.atributos])

  return (
    <>
            {atributosArray && atributosArray.map((regua) => {
                return (
                    <> 
                        {regua.titulo && <div className="div-titulo-grafico" style={{ marginTop: '3vh'}}>                        
                                <h3>{regua.titulo}</h3>
                            </div>
                        }
                        <div className="div-color" style={{ marginBottom: '3vh'}}>                            
                            {modeloRegua.map((coluna) => {
                                return (<div style={{ width: '10.5%',textAlign: 'center'}}>
                                 <div className={`${coluna.cor}`} style={{  wordSpacing: '0em'}}> {coluna.percentual}</div>
                                 <div className="div-grafico-rodape">{coluna.legenda}</div>
                                 {regua.percentualPrevisto === `${coluna.percentualPrevisto}` && (
                                    <div>
                                        <i className="pi pi-arrow-up"></i>
                                        <label>
                                        {" "}
                                        {regua.porcentagemPrevisto.toLocaleString("pt-BR", {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2,
                                        })} %
                                        </label>
                                    </div>
                                 )}
                                </div> )
                            })}
                        </div>
                        <hr/>
                    </>
                )
            })}
    </>
  )
}

export default Regua2024
